var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"like",class:{ active: _vm.isFavorite },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.ctaFavorite()}}},[_c('span',{staticClass:"icon-like"}),_vm._v("\n    Enregistrer\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457e22b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/components/cruise-product/AddToWishlistCta.vue
// module id = HBdX
// module chunks = 0